import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import "./style.css";
const ElementFadeIn = ({ children, element, defaultShow }) => {
    const [show, setShow] = useState(defaultShow ? defaultShow : false);
    const [ref, inView] = useInView({
        triggerOnce: true, // Only trigger once when the image comes into view
        threshold: 0.1, // Adjust the threshold as needed
        skip: false,
    });

    useEffect(() => {
        if (inView) {
            setTimeout(() => {
                setShow(true);
            }, 500);
        }
    }, [inView]);

    return (
        <div ref={ref} className={`fade-in ${show ? "show" : ""}`}>
            {children}
        </div>
    );
};

export default ElementFadeIn;
